import Env from '../base/env.js'
import Channels from '../base/channels.js'
import gsap from 'gsap'

class MainnavTouch
{
    constructor()
    {
        if(Env.$mainNav == null) {
            return false
        }
        this.view = Env.$mainNav
        this.$triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.$fill = this.view.querySelector('.fill')
        this.$primaryItems = this.view.querySelectorAll('.main-nav > ul > li .link')
        // Flags
        this.IS_ANIMATING = false
        // Fns
        this.events()
    }
    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }


        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                gsap.set(this.$primaryItems,{ clearProps : 'all' })
            }
        })
    }

    getStatus()
    {
        return this.view.classList.contains('is--active')
    }

    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                Channels.emit('mainnav::closing')
                this.IS_ANIMATING = true
                this.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.remove('subnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
                if(Env.mobileCSS == true) {
                  gsap.fromTo(
                    this.$subnavElements,
                    {
                      display:'block',
                    },
                    {
                      x:'100%',
                      ease:'power2.out',
                      duration:.5,
                      onComplete:()=>{
                        for ( const el of this.$subnavElements ) {
                          el.classList.remove('is-opened')
                        }
                      }
                    }
                  )
                }
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    in(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            gsap.fromTo(this.$fill,
                {
                  x : '100%',
                },
                {
                  duration:1,
                  x: "0%",
                  ease: 'power3.inOut',
                  delay: 0
                }
            ),
        ])
        timeline.add([
          gsap.fromTo(this.$primaryItems ,
              {
                autoAlpha: 0,
                x:70
              },
              {
                duration:.7,
                autoAlpha : 1,
                x:0,
                ease: 'power2.out',
                delay: 0,
                stagger:.05
              },
          ),
        ],'-=.5')
    }

    out(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
          gsap.to(this.$primaryItems ,
            {
              autoAlpha : 0,
              x:-100,
              duration:.7,
              ease: 'power2.in',
              delay: 0,
              stagger:.05
            },
          ),
          gsap.to(this.$fill ,
            {
              duration:.8,
              x: "-100%",
              ease: 'power3.inOut',
              delay: 0.5
            }
          ),
        ])
    }


    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };
}

export default MainnavTouch;
